import type { GameHistoryEntry } from "../../utils/gameHistory";

/** History records are keyed by a sequence number: a higher key is a newer game. */
export type HistoryKey = number;

/** A stored value that could not be decoded (native: unparseable JSON). */
export class CorruptRecord {
  constructor(readonly raw: unknown) {}
}

/**
 * Two stores of small records. "state" holds one record per section of
 * UnifiedAppData (user, stats, ...) plus the migration marker; "history"
 * holds one record per game. Each multi-record write is a single batch.
 */
export interface StorageAdapter {
  /** Every state record by name, decoded. */
  readState(): Promise<Map<string, unknown>>;
  writeState(records: [string, unknown][]): Promise<void>;
  deleteState(names: string[]): Promise<void>;
  /** Every history record, oldest (lowest key) first. */
  readHistory(): Promise<[HistoryKey, unknown][]>;
  writeHistory(records: [HistoryKey, GameHistoryEntry][]): Promise<void>;
  deleteHistory(keys: HistoryKey[]): Promise<void>;
  /** Remove every record from both stores. */
  clear(): Promise<void>;
}
